/**
 * @version:               1.0.0
 * @createTime:            2021.10.08
 * @updateTime:            2021.10.08
 * @author:                zhangju
 * @description
 ***/

import ccTab from '@/components/common/tab/index.vue';
import contentTable from '@/components/common/more-tab-content/content-table-02/index.vue';
export default {
    name: 'page-list',
    components: {ccTab, contentTable},
    data() {
        return {
            tabList: [
                {
                    name: '法律法规',
                    code: 'flfg'
                },
                {
                    name: '司法解释',
                    code: 'sfjs'
                },
                {
                    name: '司法文件',
                    code: 'zdxwj'
                },
                {
                    name: '条约与惯例',
                    code: 'gjgy'
                },
                {
                    name: '域外法律资料',
                    code: 'ywfl'
                }
            ],
            active: 'sfjs'
        };
    },
    computed: {
        crumbsList() {
            const list = [{
                name:'法律资源',
                key:'flzy',
                path:'/flzy'
            }];
            const listItem = this.tabList.filter(item => item.code === this.active)[0];
            listItem.key = listItem.code;
            list.push(listItem);
            return Object.freeze(list);
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.active = this.$route.query.tab || 'sfjs';
        },
        // 页签切换
        handelTabChange(code) {
            this.active = code;
        }
    }
};
